<template>
  <div class="login-container">
    <div class="login-box">
      <div class="login-header">
        <h2 class="login-title">车辆检测管理系统</h2>
        <p class="login-subtitle">Vehicle Report Management System</p>
      </div>
      
      <el-form 
        ref="loginForm" 
        :model="loginForm" 
        :rules="loginRules" 
        class="login-form"
        @submit.native.prevent="handleLogin"
      >
        <el-form-item prop="username">
          <el-input
            v-model="loginForm.username"
            placeholder="请输入用户名"
            prefix-icon="el-icon-user"
            size="large"
          />
        </el-form-item>
        
        <el-form-item prop="password">
          <el-input
            v-model="loginForm.password"
            type="password"
            placeholder="请输入密码"
            prefix-icon="el-icon-lock"
            size="large"
            @keyup.enter.native="handleLogin"
          />
        </el-form-item>
        
        <el-form-item>
          <el-button 
            type="primary" 
            :loading="loading"
            class="login-button"
            @click="handleLogin"
          >
            {{ loading ? '登录中...' : '登录' }}
          </el-button>
        </el-form-item>
      </el-form>
      

    </div>
  </div>
</template>

<script>
export default {
  name: 'Login',
  data() {
    return {
      loading: false,
      loginForm: {
        username: '',
        password: ''
      },
      loginRules: {
        username: [
          { required: true, message: '请输入用户名', trigger: 'blur' }
        ],
        password: [
          { required: true, message: '请输入密码', trigger: 'blur' },
          { min: 6, message: '密码长度不能少于6位', trigger: 'blur' }
        ]
      }
    }
  },
  methods: {
    handleLogin() {
      this.$refs.loginForm.validate(async (valid) => {
        if (valid) {
          this.loading = true
          try {
            // 模拟登录API调用
            await this.login()
            this.$message.success('登录成功')
            const redirect = this.$route.query.redirect || '/'
            this.$router.replace(redirect)
          } catch (error) {
            this.$message.error('登录失败：' + error.message)
          } finally {
            this.loading = false
          }
        }
      })
    },
    
    async login() {
      // 模拟API调用
      return new Promise((resolve, reject) => {
        setTimeout(() => {
          if (this.loginForm.username === 'admin' && this.loginForm.password === '123456') {
            // 存储用户信息
            const token = 'mock-token-' + Date.now()
            const userInfo = {
              username: this.loginForm.username,
              role: 'admin',
              token
            }
            localStorage.setItem('userInfo', JSON.stringify(userInfo))
            localStorage.setItem('token', token)
            // 兼容会话存储
            sessionStorage.setItem('userInfo', JSON.stringify(userInfo))
            sessionStorage.setItem('token', token)
            // 存储用于路由校验的凭据（假登录校验：用户名+密码）
            const auth = {
              username: this.loginForm.username,
              // 基于64的简单编码，避免明文直存
              password: btoa(this.loginForm.password)
            }
            localStorage.setItem('auth', JSON.stringify(auth))
            sessionStorage.setItem('auth', JSON.stringify(auth))
            resolve()
          } else {
            reject(new Error('用户名或密码错误'))
          }
        }, 1000)
      })
    }
  }
}
</script>

<style scoped>
.login-container {
  min-height: 100vh;
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 20px;
}

.login-box {
  background: white;
  border-radius: 10px;
  box-shadow: 0 15px 35px rgba(0, 0, 0, 0.1);
  padding: 40px;
  width: 100%;
  max-width: 400px;
}

.login-header {
  text-align: center;
  margin-bottom: 30px;
}

.login-title {
  color: #333;
  font-size: 24px;
  font-weight: 600;
  margin-bottom: 8px;
}

.login-subtitle {
  color: #666;
  font-size: 14px;
}

.login-form {
  margin-bottom: 20px;
}

.login-button {
  width: 100%;
  height: 45px;
  font-size: 16px;
}

.login-footer {
  text-align: center;
  color: #999;
  font-size: 12px;
}
</style> 